import PaymentForGoods from './payment-for-goods.vue'

export default PaymentForGoods
